<template>
  <div class="content-container">
    <div v-loading="loading" class="grid-scroll">
      <GridVx
        ref="agGrid"
        :columns="columns"
        :auto-size-cell="true"
        :auto-select-first-row="false"
        dom-layout="scroll"
        :rows="rows"
        class="agGrid"
        @refresh="onRefresh"
        @selectionChanged="isSelectedRow = true"
      />
    </div>
    <div class="button-containers mb-0">
      <button
        :disabled="!isSelectedRow"
        class="btn primary small outline"
        @click="deleteTax"
      >
        {{ $t('button.delete') }}
      </button>
      <button
        :disabled="!isSelectedRow"
        class="btn primary small"
        @click="editTax"
      >
        {{ $t('button.modify') }}
      </button>
      <button class="btn primary small" @click="openDialog">
        {{ $t('button.add') }}
      </button>
    </div>
    <el-dialog
      :title="isEdit ? $t('dialog.titleTaxUpdate') : $t('dialog.titleTaxAdd')"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="500px"
    >
      <!-- <el-form :model="form">
        <el-form-item label="Mã*">
          <el-input v-model="taxItem.code" placeholder="Nhập thông tin" />
        </el-form-item>
        <el-form-item label="Mức thuế(%)*">
          <el-input v-model="taxItem.level" placeholder="Nhập thông tin" />
        </el-form-item>
        <el-form-item label="Mô tả*">
          <el-input v-model="taxItem.desc" placeholder="Nhập thông tin" />
        </el-form-item>
        <el-form-item label="Thứ tự">
          <el-input v-model="taxItem.order" placeholder="Nhập thông tin" />
        </el-form-item>
      </el-form> -->
      <validation-observer ref="formValidator">
        <div class="das-form-container">
          <div class="das-form-group">
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <validation-provider
                  rules="required|max:20"
                  :name="$t('validator.code')"
                >
                  <div class="das-form-input">
                    <div class="label required">{{ $t('dialog.code') }}:</div>
                    <div class="child-w-80">
                      <input
                        v-model="taxItem.code"
                        type="text"
                        :readonly="isEdit"
                      />
                    </div>
                  </div>
                </validation-provider>
              </div>
              <div class="das-form-col col-6">
                <validation-provider
                  rules="required|integer|percent"
                  name="Mức thuế"
                >
                  <div class="das-form-input">
                    <div class="label required">
                      {{ $t('dialog.taxLevel') }}:
                    </div>
                    <div class="child-w-80">
                      <input
                        v-model="taxItem.level"
                        v-numeric-only
                        type="text"
                      />
                    </div>
                  </div>
                </validation-provider>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <validation-provider rules="required|max: 200" name="Mô tả">
                  <div class="das-form-input">
                    <div class="label required">{{ $t('dialog.desc') }}:</div>
                    <div class="child-w-80">
                      <textarea v-model="taxItem.desc" rows="4" />
                    </div>
                  </div>
                </validation-provider>
              </div>
            </div>
          </div>
        </div>
      </validation-observer>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="dialogFormVisible = false"
          >
            {{ $t('button.cancel') }}
          </button>
          <button v-if="isEdit" class="btn primary small" @click="updateTax">
            {{ $t('button.update') }}
          </button>
          <button v-else class="btn primary small" @click="addTax">
            {{ $t('button.create') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import bus from '@/utils/bus'
import {
  getListBuildingApi,
  addBuildingApi,
  updateBuildingApi,
  deleteBuildingApi
} from '@/api/Room/building.js'
import {
  getListTaxApi,
  addTaxApi,
  updateTaxApi,
  deleteTaxApi
} from '@/api/configuration/accounting/tax.js'
import { Message } from 'element-ui'
export default {
  data() {
    return {
      isSelectedRow: false,
      loading: false,
      columns: [
        {
          headerName: this.$t('grid.column.code'),
          field: 'code',
          tooltipField: 'code',
          maxWidth: 200
        },
        {
          headerName: this.$t('grid.column.taxLevel'),
          field: 'level',
          tooltipField: 'level',
          maxWidth: 200
        },
        {
          headerName: this.$t('grid.column.desc'),
          field: 'desc',
          tooltipField: 'desc'
        }
      ],
      rowId: null,
      rows: [],
      form: [],
      titlePopup: '',
      totalPage: 0,
      currentPage: 0,
      isEdit: false,
      dialogFormVisible: false,
      searchParams: {},
      taxItem: {
        code: null,
        level: null,
        desc: '',
        order: 1
      }
    }
  },
  watch: {
    dialogFormVisible() {
      this.dialogFormVisible ? null : this.resetInfo()
    }
  },
  beforeMount() {
    this.context = { componentParent: this }
  },
  mounted() {
    this.attachData()
  },
  methods: {
    onRefresh(data) {
      let params = {
        orderBy: data.orderBy,
        orderTp: data.sort
      }
      this.searchParams = { ...this.searchParams, ...params }
      this.attachData()
    },
    resetInfo() {
      this.isEdit = false
      this.$nullValueInObj(this.taxItem)
    },
    openDialog() {
      this.dialogFormVisible = true
    },
    // table controller
    onRowClick(index) {
      document.getElementById(`currency-${index}`).classList.add('row-focus')
      if (this.rowId != null) {
        document
          .getElementById(`currency-${this.rowId}`)
          .classList.remove('row-focus')
      }
      this.rowId = index
    },
    // CRUD
    async addTax() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) === false) {
        return
      }
      let data = await addTaxApi(this.taxItem)
        .then(async res => {
          const message = res.message
          await this.attachData()
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    editTax() {
      const gridApi = this.$refs.agGrid.gridApi
      const row = gridApi.getSelectedRows()[0]
      if (!row) {
        this.$message({
          type: 'error',
          message: this.$t('errorMsg.selectRow')
        })
        return false
      }
      this.isEdit = true
      this.dialogFormVisible = true
      Object.assign(this.taxItem, row)
    },
    async deleteTax() {
      const gridApi = this.$refs.agGrid.gridApi
      const row = gridApi.getSelectedRows()[0]
      if (!row) {
        this.$message({
          type: 'error',
          message: this.$t('errorMsg.selectRow')
        })
        return false
      }
      const id = row.id
      const id_list = []
      id ? id_list.push(id) : null
      if (id_list.length == 0) {
        this.$message({
          type: 'error',
          message: this.$t('errorMsg.selectRow')
        })
      } else {
        this.$vxConfirm('Bạn chắc chắn muốn xoá loại thuế này?', () => {
          deleteTaxApi({
            id_list: id_list
          })
            .then(async res => {
              const message = res.message
              await this.attachData()
              this.dialogFormVisible = false
              this.$message({
                type: 'success',
                message: this.$t(`successMsg.${message}`)
              })
            })
            .catch(error => {
              const message = error.response?.data?.message || 'default'
              this.$message({
                type: 'error',
                message: this.$t(`errorMsg.${message}`)
              })
            })
        })
      }
    },
    async updateTax() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) === false) {
        return
      }
      let data = await updateTaxApi(this.taxItem)
        .then(async res => {
          const message = res.message
          await this.attachData()
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    async attachData() {
      this.loading = true
      let data = await getListTaxApi(this.searchParams)
      this.loading = false
      this.isSelectedRow = false
      this.rows = data.data
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
